module.exports = __webpack_public_path__ + "static/img/chanta (25).24607af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chanta/chanta (25).jpg
// module id = xYwb
// module chunks = 0